<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="printAll('printAllAccountReceivableList')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllAccountReceivable()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="customerName"
                label="Customer Name"
                type="text"
                v-model="queryParams.customerName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="accountReceivableStatusList"
                label="Choose Status..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="accountReceivableTypeList"
                label="Choose Type..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.arType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="chequeNo"
                label="Cheque No"
                type="text"
                v-model="queryParams.chequeNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-title class="blue darken-3">
                  <span class="headline white--text">Summary</span>
                </v-card-title>
                <v-card-text class="font-weight-bold">
                  <div>
                    <span>Total Cash Amount :</span>
                    <v-chip>
                      <span>{{ totalCashAmount | decFormat(6) }}</span>
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="accountReceivableList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                {{ props.item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td>{{ props.item.accountReceiveStatus }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.customer.name }}</td>
              <td>{{ props.item.arType }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.operationSettingName }}</td>
              <td>{{ props.item.saleInvoice }}</td>
              <td>{{ props.item.advancedIssueNo }}</td>
              <td style="text-align: right">{{ props.item.cashAmount }}</td>
              <td>{{ props.item.remark }}</td>
              <td>{{ props.item.chequeNo }}</td>
              <td>{{ props.item.createdBy }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds | format-ms-date
                }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <damage report> -->
    <div
      id="printAllAccountReceivableList"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Account Receivable</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <div style="text-align: left">
        <p style="font-size: 15px; margin: 1px">
          Total Cash Amount : {{ totalCashAmount | decFormat(6) }}
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="text-align: left">Issue Date</th>
              <th style="text-align: left">Issue No</th>
              <th style="text-align: left">Customer</th>
              <th style="text-align: left">Type</th>
              <th style="text-align: left">Shop Name</th>
              <th style="text-align: left">Cash Amount</th>
              <th style="text-align: left">Status</th>
              <th style="text-align: left">Remark</th>
              <th style="text-align: left">Created By</th>
              <th style="text-align: left">Updated By</th>
              <th style="text-align: left">Updated Date</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allaccountReceivableList" :key="index">
              <td style="text-align: left">
                {{ item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td style="text-align: left">{{ item.issueNo }}</td>
              <td style="text-align: left">{{ item.customer.name }}</td>
              <td style="text-align: left">{{ item.arType }}</td>
              <td style="text-align: left">{{ item.shopName }}</td>
              <td style="text-align: left">{{ item.cashAmount }}</td>
              <td style="text-align: left">{{ item.accountReceiveStatus }}</td>
              <td style="text-align: left">{{ item.remark }}</td>
              <td style="text-align: left">{{ item.createdBy }}</td>
              <td style="text-align: left">{{ item.updatedBy }}</td>
              <td style="text-align: left">
                {{ item.updatedDateInMilliSeconds | format-ms-date }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>
<script>
import { accountReceivableService } from "../../services/account-receivable-service";
import { commonService } from "../../services/common-service";
import { shopService } from "../../services/shop-service";

export default {
  name: "AccountReceivableList",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Account Receivable",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "accountReceiveStatus", sortable: false },
      {
        text: "Issue Date",
        align: "left",
        value: "warehouse.name",
        sortable: false,
      },
      { text: "Issue No", align: "left", value: "issueNo", sortable: false },
      { text: "Customer", value: "customer.name", sortable: false },
      { text: "Type", value: "arType", sortable: false },
      { text: "Shop", value: "shopName", sortable: false },
      { text: "Operation Setting Name", value: "operationSettingName", sortable: false },
      { text: "Sale Invoice", value: "saleInvoice", sortable: false },
      { text: "Advanced Invoice", value: "advancedIssueNo", sortable: false },
      { text: "Cash Amount", value: "cashAmount", sortable: false },
      { text: "Remark", value: "remark", sortable: false },
      { text: "Cheque No", value: "chequeNo", sortable: false },
      { text: "Created By", value: "createdBy", sortable: false },
      { text: "Updated By", value: "updatedBy", sortable: false },
      { text: "Updated Date", value: "updatedDate", sortable: false },
    ],
    accountReceivableStatusList: [
      { label: "----All----", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    accountReceivableTypeList: [
      { label: "----All----", value: "" },
      { label: "Advanced", value: "ADVANCED" },
      { label: "Advance Repayment", value: "ADVANCE_REPAYMENT" },
      { label: "Credit Receive", value: "CREDIT_RECEIVE" },
      // { label: "TGI Credit Receive", value: "TGI_CREDIT_RECEIVE" },
      { label: "Advance Credit Receive", value: "ADVANCE_CREDIT_RECEIVE" },
      { label: "Discount", value: "DISCOUNT" },
      // { label: "Damage", value: "DAMAGE" },
      // { label: "Delivery", value: "DELIVERY" },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      customerName: "",
      status: "",
      arType: "",
      shopId: "",
      issueNo: "",
      chequeNo: "",
    },
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    totalCashAmount: 0,
    totalAmount: 0,
    totalRows: 0,
    showListLoading: false,
    buttonLoading: false,
    printAllButtonLoading: false,
    clonequeryParams: new Object(),
    accountReceivableList: [],
    decimalFormat: "",
    allaccountReceivableList: [],
    shopList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getAccountReceivableList();
      },
      deep: true,
    },
  },
  created() {
    this.getShopList();
    //for deep linking
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.customerName) {
      this.queryParams.customerName = this.$route.query.customerName;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.chequeNo) {
      this.queryParams.chequeNo = this.$route.query.chequeNo;
    }
    if (this.$route.query.arType) {
      this.queryParams.arType = this.$route.query.arType;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.onSearch();
    this.decimalFormat = commonService.formatdecimal();
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "accountreceivables",
        query: this.queryParams,
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getAccountReceivableList();
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    getAccountReceivableList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      accountReceivableService
        .getAccountReceivableList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.accountReceivableList = res.data.accountReceivableList;
            this.totalRows = res.data.totalElements;
            this.totalCashAmount = res.data.totalCashAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    printAll(divName) {
      this.printAllButtonLoading = true;
      accountReceivableService
        .getAllAccountReceivableList(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.allaccountReceivableList = res.data.accountReceivableList;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    exportAllAccountReceivable() {
      this.printAllButtonLoading = true;
      accountReceivableService
        .exportAllAccountReceivableDetailExcel(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .finally(() => {
          this.printAllButtonLoading = false;
        });
    },
    onRegister() {
      console.log("onRegister");
      this.$router.push("/accountreceivable/new");
    },
    onEdit(damage) {
      // go to details page
      this.$router.push("/accountreceivable/" + damage.id);
    },
  },
};
</script>
